import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { fetchSalesLocation } from 'queries/sales/location'
import { SalesFetchProps } from 'types/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'

export function useSalesLocation({
    env,
    accessToken,
    location,
    filters,
    dynamicSubPath,
}: SalesFetchProps) {
    const { tenMinutes } = TIME
    const { trackEvent } = useAnalytics()
    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.SALES_LOCATION, location],
        () =>
            fetchSalesLocation({
                env,
                accessToken,
                location,
                filters,
                dynamicSubPath,
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
